import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { MoneyForBuckService } from 'src/app/service/money-for-buck-service/money-for-buck.service';
import { sweetAlert } from 'src/app/utils/swal';
import { DriversService } from '../../../drivers/drivers-service/drivers-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-add-mfb',
  templateUrl: './add-mfb.component.html',
  styleUrls: ['./add-mfb.component.css']
})
export class AddMfbComponent implements OnInit, OnDestroy {
  mfbForm : FormGroup
  submitted: boolean;
  selectedDriver: any;
  user: any;
  timeZone: any;
  driverList: any = [];
  buckId: string;
  constructor(
    private fb: FormBuilder,
    private mfbService: MoneyForBuckService,
    private driverService : DriversService,
    private sharedDataService : SharedDataService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }


  ngOnInit() {
    if (this.activatedRoute.snapshot.url.length === 4 && this.activatedRoute.snapshot.url[3].path === 'edit') {
      this.buckId = this.activatedRoute.snapshot.url[2].path;
    }
    this.mfbForm = this.fb.group({
      loadedMilesRate: ['',Validators.required],
      deadMilesRate: ['',Validators.required],
      preStartDate: ['',Validators.required],
      startTime: ['',Validators.required],
      preEndDate: ['',Validators.required],
      endTime: ['',Validators.required],
      status: ['',Validators.required],
      driver: ['',Validators.required]
    })
    this.getUser();
    if(this.buckId){
      this.getBuckById();
    }
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = user.timeZone;
          this.getDriverList();

        }
      });
  }

  getBuckById() {
    this.mfbService
      .getBucksbyId(this.buckId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.mfbForm.patchValue({
            ...data,
            preStartDate: moment(data.startTime).startOf('day'),
            startTime : data.startTime,
            preEndDate: moment(data.endTime).endOf('day'),
            endTime: data.endTime
          })
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }

  getDriverList() {
    this.driverService
      .getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverList = data;
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }

  onSubmit() {

    this.submitted = true;
    if (this.mfbForm.invalid) {
      return;
    }
    if (this.selectedDriver) {
      this.mfbForm.patchValue({
        driver: this.selectedDriver
      })
    }
    let payload = this.mfbForm.value;
    this.mfbService.addBucks(payload, this.buckId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            // this.router.navigateByUrl('mfb');
            const currentUrl = this.activatedRoute.snapshot.url[1].path; 
            this.router.navigate([`/mfb/${currentUrl}`]);
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }
  onDateChange(evt, control: AbstractControl) {
    if (evt) {
      control.setValue(moment(evt).toISOString());
    }
  }

  get form(){
    return this.mfbForm.controls;
  }

  onSelectDriver(event){
    this.selectedDriver = event
  }

  ngOnDestroy(): void {
  }
}
